export default __webpack_public_path__ + "static/media/Ballroll_00146.289da6d4.png";